<template>
	<span v-if="visible && inputType === 'password'" class="inputs-row fd-pasword"><input :type="passMask ? 'password':'text'" v-model="value" :class="[clazz, errorClass, 'input-password']" :style="myStyle" :readonly="ro" v-bind="attrs"/><icon-button
		:name="passMask ? 'eye-cross' : 'eye'" class="pass-show" @click="toggleMask"></icon-button></span>
	<input v-else-if="visible" :type="inputType" v-model="value" :class="[clazz, errorClass, 'input-'+inputType]" :style="myStyle" :readonly="ro" v-bind="attrs"/>
</template>

<script setup lang="ts">
import useEditor, {type EditorProps, editorProps} from "./Editor";
import {computed, ref} from "vue";
import IconButton from "../helpers/IconButton.vue";
import type {Input} from "@t/fd/editor/Input";

const uprops = defineProps({...editorProps});
const props = uprops as EditorProps;

const input = computed<Input>(() => props.part as Input);

const {visible, value, clazz, style, ro, errorClass, errorMessage, tabindexBinding} = useEditor(props);

const passMask = ref<boolean>(true);

function toggleMask() {
	passMask.value = !passMask.value;
}

const inputType = computed(() => {
	if (input.value.itype) {
		return input.value.itype;
	} else {
		if ("integer" === input.value.cast) return "number";
		return "text";
	}
});

const myStyle = computed<any>(() => {
	const s = style.value;
	if (typeof input.value.size === "number") {
		return [ "max-width: calc("+input.value.size+" * 1ch + 2 * var(--input-h-padding))", s ];
	}
	return s;
});

const attrs = computed(() => {
	const a: any = tabindexBinding();
	if (typeof input.value.placeholder === "string") a.placeholder = input.value.placeholder;
	if (typeof input.value.maxLength === "number") {
		if (inputType.value==="number" && input.value.maxLength<7) {
			a.max=Math.pow(10,input.value.maxLength)-1
		}
		else {
			a.maxlength = input.value.maxLength;
		}
	}
	//if (typeof input.value.size === "number") a.size = input.value.size;
	if (typeof input.value.autocomplete === "string") a.autocomplete = input.value.autocomplete;
	const errMsg = errorMessage.value;
	if (errMsg) a.title = errMsg;	// if error put as title
	return a;
});

</script>

<style>
.fi.pass-show {
	line-height: var(--input-height);
}

.pass-show {
	margin-right: var(--input-h-padding);
}

/** These input types will be flexy (will grow inside flex container, e.g. .app-field) */
.input-text,
.input-email,
.input-file,
.input-range,
.input-search,
.input-url,
.input-password,
.fd-pasword {
	flex-grow: 1;
}

</style>
